import React from 'react'
import Text from '~/views/components/ui/Text'
import {
  CardBodyContainer,
  CardBodyContent,
  CardHeaderContainer,
  ContainerCard,
} from '~/views/components/ProjectOverview/components/ProjectOverviewCard'
import ProfitContent from './components/TotalProfitContent'
import { useStaticLabels } from 'shared/hooks/use-static-labels'

type ProjectOverviewProfitCardProps = {
  totalProfit?: number | null
  show?: boolean | null
  loading?: boolean | null
}

export default function ProjectOverviewProfitCard(
  props: ProjectOverviewProfitCardProps,
) {
  const { totalProfit, show, loading } = props

  if (!show) {
    return null
  }

  return (
    <ContainerCard>
      <ProfitCardHeader />

      <ProfitCardBody totalProfit={totalProfit} loading={loading === true} />
    </ContainerCard>
  )
}

function ProfitCardHeader() {
  const [getCommonLabel] = useStaticLabels(['common'])

  return (
    <CardHeaderContainer>
      <Text weight={'bold'} size={'large'}>
        {getCommonLabel('profit')}
      </Text>
    </CardHeaderContainer>
  )
}

type ProfitCardBodyProps = {
  totalProfit?: number | null
  loading: boolean
}

function ProfitCardBody({ totalProfit, loading }: ProfitCardBodyProps) {
  return (
    <CardBodyContainer>
      <CardBodyContent>
        <ProfitContent totalProfit={totalProfit} loading={loading} />
        {/*<LineDivider />*/}
      </CardBodyContent>
    </CardBodyContainer>
  )
}
